/**
 * 西班牙语
 */
var esES = {
  locale: 'es-ES',
  Common: {
    pleaseInput: 'Por favor ingresa',
    pleaseSelect: 'Por favor selecciona',
    confirm: 'Confirmar',
    clear: 'Limpiar',
    cancel: 'Cancelar',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    reset: 'Restablecer'
  },
  Exception: {
    emptyData: 'Sin datos',
    error: 'Error en la página. Inténtalo de nuevo más tarde',
    networkError: 'Error de red'
  },
  List: {
    noMoreData: 'No hay más datos',
    networkError: 'Error de red',
    clickRetry: 'Intentar de nuevo'
  },
  DateRangePicker: {
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    timeRange: 'Rango de tiempo'
  }
};

export { esES as default };
